export const DEFAULT_MASK = '000-000-0000-00000';
export const TIME_MASK = 'Hh:m0';
